/* Load brand info for vendor collection pages */
(function() {
	async function loadBrandInfo() {
		console.log('Brand info script loaded');
		console.log('Current path:', window.location.pathname);
		console.log('Current search:', window.location.search);

		// Check if we're on the vendors collection page
		if (!window.location.pathname.includes('/collections/vendors')) {
			console.log('Not a vendors page');
			return;
		}

		// Extract vendor name from URL query string
		const urlParams = new URLSearchParams(window.location.search);
		const vendorName = urlParams.get('q');
		console.log('Vendor name from URL:', vendorName);

		if (!vendorName) {
			console.log('No vendor name in URL parameter q');
			return;
		}

		let brandInfoContainer = document.querySelector('[data-brand-info]');
		console.log('Brand info container:', brandInfoContainer);

		if (!brandInfoContainer) {
			console.log('No brand info container found in DOM');
			return;
		}

		const logoContainer = brandInfoContainer.querySelector('[data-brand-logo]');
		const claimContainer = brandInfoContainer.querySelector('[data-brand-claim]');
		const descriptionContainer = brandInfoContainer.querySelector('[data-brand-description]');

		try {
			const encodedVendor = encodeURIComponent(vendorName);
			console.log('Fetching brand data for:', encodedVendor);
			const response = await fetch(`https://sync.craftdepot.de/brands/${encodedVendor}`);

			if (!response.ok) {
				console.log('API response not ok:', response.status);
				return;
			}

			const data = await response.json();
			console.log('Brand data received:', data);

			if (!data.brand) {
				console.log('No brand data in response');
				return;
			}

			const brand = data.brand;
			let hasLogo = false;

			// Add brand name to schema.org markup
			const brandNameMeta = document.createElement('meta');
			brandNameMeta.setAttribute('itemprop', 'name');
			brandNameMeta.setAttribute('content', brand.title || vendorName);
			brandInfoContainer.appendChild(brandNameMeta);

			// Add logo and hide h1 text if logo exists
			if (data.logos && data.logos.large) {
				const img = document.createElement('img');
				img.src = data.logos.large;
				img.alt = brand.title || vendorName;
				img.loading = 'lazy';
				logoContainer.appendChild(img);
				hasLogo = true;

				// Hide h1 visible text but keep it for SEO
				const titleElement = document.querySelector('[data-brand-title]');
				if (titleElement) {
					// Keep text but make it hidden for screen readers only
					titleElement.style.position = 'absolute';
					titleElement.style.width = '1px';
					titleElement.style.height = '1px';
					titleElement.style.overflow = 'hidden';
					titleElement.style.clip = 'rect(0, 0, 0, 0)';
					titleElement.style.whiteSpace = 'nowrap';
				}

				console.log('Logo added and h1 hidden');
			}

			// Add claim (SEO: use h2 for structure)
			if (brand.claim && brand.claim.trim() !== '') {
				const claimElement = document.createElement('h2');
				claimElement.textContent = brand.claim;
				claimElement.className = 'brand-info__claim-text';
				claimContainer.appendChild(claimElement);
				console.log('Claim added');
			}

			// Add description (SEO: semantic content)
			if (brand.description && brand.description.trim() !== '') {
				const descriptionElement = document.createElement('div');
				descriptionElement.textContent = brand.description;
				descriptionElement.className = 'brand-info__description-text';
				descriptionContainer.appendChild(descriptionElement);
				console.log('Description added');
			}

			console.log('Brand info loaded successfully');
		} catch (error) {
			console.error('Failed to load brand info:', error);
		}
	}

	// Load async after page load to not block rendering
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function() {
			setTimeout(loadBrandInfo, 100);
		});
	} else {
		setTimeout(loadBrandInfo, 100);
	}
})();
